﻿import React from 'react';
import { connect } from 'react-redux';

import { getAchievementsData, getNewAchievementsData } from '../State/actions';

import InfoLoader from '../../../UI/InfoLoader';
import NewAchievements from './NewAchievements';
import Achievements from './Achievements';

const AchievementsPage = (props) => {

    const [showList, setShowList] = React.useState(false);
    const [collectedStars, setCollectedStars] = React.useState([]);
    const [sync, setSyncCompleted] = React.useState(false);

    React.useEffect(() => {
        props.loadAchievements();
    }, []);

    let data = [];

    if (props.achievements) {
        data = props.achievements;
    }

    React.useEffect(() => {
        if (data.initialSyncCompleted === true) {
            setSyncCompleted(!sync);
        }
    }, [data.syncCompleted]);

    React.useEffect(() => {
        props.loadNewAchievements();
    }, []);

    let newData = [];

    if (props.newAchievements) {
        newData = props.newAchievements;
    }

    let prevStars = [];
    let newStars = [];
    let allStars = [];

    if (data.achievements && data.achievements.length > 0) {
        allStars = data.achievements;

        if (newData.newAchievements.length > 0) {
            newStars = allStars.filter(i => newData.newAchievements.includes(i.achievementType));
            prevStars = allStars.filter(i => !newData.newAchievements.includes(i.achievementType));
        }
    }

    React.useEffect(() => {
        setTimeout(() => {
            setShowList(!showList);
        }, 800)
    }, []);

    React.useEffect(() => {
        if (allStars.length > 0) {

            allStars.map((collectedStar, index) => {

                if (collectedStar.isAchieved === true) {
                    setCollectedStars(collectedStars => ([...collectedStars, collectedStar.isAchieved]));
                } 
            })
        }
    }, [allStars]);


    return (
           <div className={`my-pages-achievements ${showList ? "js-animate" : ""}`}>

            {!sync && <InfoLoader loaderText={'Just nu hämtar vi dina stjärnor. Kom tillbaka inom kort för att se vilka stjärnor du har.'} /> }

           {sync &&
                <React.Fragment>
                     <p className="my-pages-achievements__status">
                        <span className="my-pages-achievements__status--bold">Status</span>
                        <span className="my-pages-achievements__status__text">Du har samlat {collectedStars.length} av {allStars.length} stjärnor</span>
                    </p>
                    <ul className="my-pages-achievements__list">

                        {newStars.length > 0
                            && <NewAchievements data={newStars} />
                        }

                        {newStars.length > 0 && prevStars.length > 0 &&
                            <Achievements data={prevStars} />
                        }

                        {newStars.length < 1
                            && <Achievements data={allStars} />
                        }
                    </ul>
                </React.Fragment>
           }
           </div >
        )
   }

                  
const mapStateToProps = (state) => {
    return {
        achievements: state.achievementsData,
        newAchievements: state.newAchievementsData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadAchievements: (achievements) => dispatch(getAchievementsData(achievements)),
        loadNewAchievements: (newAchievements) => dispatch(getNewAchievementsData(newAchievements)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AchievementsPage);


